<form class="terms-step" [formGroup]="form">
  <div class="terms-step__groups" formArrayName="groups">
    <ng-container *ngFor="let contact of groups.controls; let index = index">
      <ng-container [formGroupName]="index">
        <div class="terms-step__group">
          <div class="terms-step__group_header">
            <span>{{ 'components.loyaltyTermsStep.labels.offer' | translate }} {{ index + 1 }}</span>

            <button
              tuiIconButton
              type="button"
              size="m"
              iconStart="@tui.trash-2"
              appearance="outline-grayscale"
              tuiAppearanceMode="checked"
              [tuiHint]="isDesktop ? ('common.buttons.delete' | translate) : ''"
              (click)="removeGroup(index)"
            ></button>
          </div>

          <input type="hidden" formControlName="id" />

          <tui-input
            *ngIf="groups.controls.length > 1"
            formControlName="groupName"
            [tabindex]="10 + index"
            [tuiTextfieldSize]="isDesktop ? 'l' : 'm'"
          >
            {{ 'components.loyaltyTermsStep.fields.groupName' | translate }}
            <span class="tui-required"></span>
          </tui-input>

          <tui-input-number
            *ngIf="getDiscountType(index) !== 'tag'"
            [tabindex]="20 + index"
            formControlName="discount"
            [tuiNumberFormat]="{ precision: 0 }"
            [tuiTextfieldSize]="isDesktop ? 'l' : 'm'"
            [min]="1"
            [max]="getDiscountType(index) === 'rate' ? 99 : 10000000"
          >
            {{ 'components.loyaltyTermsStep.fields.discount' | translate }}

            <input
              tuiTextfieldLegacy
              type="text"
              [placeholder]="'components.loyaltyTermsStep.fields.enterDiscount' | translate"
            />
            <span class="tui-required"></span>
          </tui-input-number>

          <tui-input
            *ngIf="getDiscountType(index) === 'tag'"
            [tabindex]="20 + index"
            [maxlength]="100"
            formControlName="discount"
            [tuiTextfieldSize]="isDesktop ? 'l' : 'm'"
          >
            {{ 'components.loyaltyTermsStep.fields.discount' | translate }}

            <input
              tuiTextfieldLegacy
              type="text"
              [placeholder]="'components.loyaltyTermsStep.fields.enterDiscount' | translate"
            />
          </tui-input>

          <tui-radio-list
            formControlName="discountType"
            [tabIndex]="25 + index"
            [style.flex-direction]="'row'"
            [size]="'s'"
            [itemContent]="discountTypeItemContent"
            [items]="discountTypeItems"
          ></tui-radio-list>

          <ng-template #discountTypeItemContent let-data>
            <span>{{ getDiscountTypeName(data) }}</span>
          </ng-template>

          <span class="terms-step__group_article">{{ 'components.loyaltyTermsStep.labels.terms' | translate }}</span>

          <tui-textarea
            [tabindex]="30 + index"
            formControlName="description"
            [tuiTextfieldSize]="isDesktop ? 'l' : 'm'"
            [maxLength]="1000"
            [rows]="12"
            [expandable]="true"
          >
            {{ 'components.loyaltyTermsStep.fields.description' | translate }}
            <span class="tui-required"></span>
          </tui-textarea>

          <tui-tabs
            class="terms-step__code-tabs"
            [activeItemIndex]="getCodeMode(contact.value.isPermanentCode)"
            (activeItemIndexChange)="setCodeMode(contact, $event)"
          >
            <button tuiTab>
              {{ 'components.loyaltyTermsStep.buttons.permanentCode' | translate }}
            </button>
            <button tuiTab>
              {{ 'components.loyaltyTermsStep.buttons.uniqueCodes' | translate }}
            </button>
          </tui-tabs>

          <label tuiLabel>
            <input tuiCheckbox type="checkbox" formControlName="showAsQRCode" [size]="isDesktop ? 'm' : 's'" />
            {{ 'components.loyaltyTermsStep.fields.showAsQRCode' | translate }}
          </label>

          <label tuiLabel>
            <input tuiCheckbox type="checkbox" formControlName="showAsBarcode" [size]="isDesktop ? 'm' : 's'" />
            {{ 'components.loyaltyTermsStep.fields.showAsBarcode' | translate }}
          </label>

          <ng-container *ngIf="contact.value.isPermanentCode; else uniqueCodes">
            <div>
              <tui-input [tabindex]="40 + index" formControlName="promoCode" [tuiTextfieldSize]="isDesktop ? 'l' : 'm'">
                {{ 'components.loyaltyTermsStep.fields.promoCode' | translate }}

                <input
                  tuiTextfieldLegacy
                  type="text"
                  [placeholder]="'components.loyaltyTermsStep.fields.enterCode' | translate"
                />
              </tui-input>

              <tui-error
                *ngIf="contact.hasError('qrCodeRequired')"
                [error]="'components.loyaltyTermsStep.labels.qrCodeRequired' | translate"
              ></tui-error>

              <tui-error
                *ngIf="contact.get('promoCode')?.errors?.ean13Invalid"
                [error]="'components.productDialog.alerts.errors.ean13Invalid' | translate"
              ></tui-error>
            </div>

            <div class="terms-step__group_qr-code-file">
              <span>{{ 'components.loyaltyTermsStep.labels.uploadQRCode' | translate }}</span>

              <app-input-files
                formControlName="qrCodeImage"
                [tabindex]="50 + index"
                [accept]="acceptImageFileMask"
                [maxFileSize]="maxFileSize"
                [size]="isMobile ? 'm' : 'l'"
                (rejectedFiles)="getRejectedQrCodeImageControl(index)?.setValue($event)"
              ></app-input-files>
            </div>
          </ng-container>

          <ng-template #uniqueCodes>
            <div>
              <span class="text_color-grey">{{ 'components.loyaltyTermsStep.labels.uniqueCodes' | translate }}</span>

              <app-input-files
                formControlName="uniqueCodes"
                [tabIndex]="40 + index"
                [size]="isDesktop ? 'l' : 'm'"
                [maxFileSize]="maxFileSize"
                [accept]="acceptExcelFileMask"
              ></app-input-files>

              <app-download-link class="example-file" fileLink="assets/docs/Шаблон импорта уникальных кодов.xlsx">
                {{ 'components.uniqueCodes.buttons.exampleFile' | translate }}
              </app-download-link>
            </div>

            <label tuiLabel>
              <input tuiCheckbox type="checkbox" formControlName="isSingleCodeUse" [size]="isDesktop ? 'm' : 's'" />
              {{ 'components.loyaltyTermsStep.fields.isMultipleCodeUse' | translate }}
            </label>

            <div *ngIf="!contact.value.isSingleCodeUse" class="max-code-use-per-month">
              <span>{{ 'components.loyaltyTermsStep.fields.maxCodeUsePerMonthPart1' | translate }}</span>

              <tui-input-number
                class="max-code-use-per-month__input"
                formControlName="maxCodeUsePerMonth"
                tuiTextfieldSize="s"
                [tuiNumberFormat]="{ precision: 0 }"
                [tabindex]="50 + index"
                [min]="0"
                [max]="99"
                [tuiTextfieldLabelOutside]="true"
              ></tui-input-number>

              <span
                [translate]="'components.loyaltyTermsStep.fields.maxCodeUsePerMonthPart2'"
                [translateParams]="{
                  value:
                    contact.value.maxCodeUsePerMonth
                    | numeralPlurals
                      : [
                          'common.labels.timeOne' | translate,
                          'common.labels.timeFew' | translate,
                          'common.labels.timeMany' | translate,
                        ]
                      : true,
                }"
              ></span>
            </div>
          </ng-template>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div tuiGroup class="add-button" [collapsed]="true">
    <button
      tuiButton
      appearance="outline-grayscale"
      tuiAppearanceMode="checked"
      [size]="'m'"
      type="button"
      (click)="addGroup()"
    >
      {{ 'components.loyaltyTermsStep.buttons.addGroup' | translate }}
    </button>

    <button
      tuiIconButton
      class="tui-group__auto-width-item"
      appearance="outline-grayscale"
      tuiAppearanceMode="checked"
      iconStart="@tui.circle-plus"
      [size]="'m'"
      type="button"
      (click)="addGroup()"
    ></button>
  </div>
</form>
